import { render, staticRenderFns } from "./VDeliveryTime.vue?vue&type=template&id=2925f0b4"
import script from "./VDeliveryTime.vue?vue&type=script&lang=ts"
export * from "./VDeliveryTime.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports